import { render } from "./DisplayResultColumn.vue?vue&type=template&id=6a340b35&scoped=true"
import script from "./DisplayResultColumn.vue?vue&type=script&lang=js"
export * from "./DisplayResultColumn.vue?vue&type=script&lang=js"

import "./DisplayResultColumn.vue?vue&type=style&index=0&id=6a340b35&scoped=true&lang=scss"
/* hot reload */
if (module.hot) {
  script.__hmrId = "6a340b35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a340b35', script)) {
    api.reload('6a340b35', script)
  }
  
  module.hot.accept("./DisplayResultColumn.vue?vue&type=template&id=6a340b35&scoped=true", () => {
    api.rerender('6a340b35', render)
  })

}


import exportComponent from "/data/tfs-agent-build-2/agent/_work/4/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a340b35"],['__file',"src/components/DisplayResultColumn.vue"]])